import { intersect, literal, nullable, partial, string, struct, union } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Scopes } from '../Scopes';

export const Request = intersect(
	struct({
		firstName: string,
		lastName: string,
		email: string,
		employmentStartAt: nullable(string),
		cohort: nullable(string),
		scopes: Scopes,
	})
)(
	union(
		struct({
			// Whether to also create an IDP user granting the new user access to ROME.
			// When false a stub user is created: a platform record with no ROME login.
			grantPlatformAccess: literal(false),
		}),
		intersect(
			struct({
				// Whether to also create an IDP user granting the new user access to ROME.
				// When false a stub user is created: a platform record with no ROME login.
				grantPlatformAccess: literal(true),
			})
		)(
			partial({
				temporaryPassword: iotsUtils.NotEmptyString,
			})
		)
	)
);
